import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import Button from '@material-ui/core/Button';
import OpacityModal from 'component/opacity.modal.component';
import ReactTable from 'react-table';
import { Description, Done } from '@material-ui/icons';
import axios from 'axios';
import history from 'config/history';

function TemplateModal(props) {
  const [reference, setReference] = useState(null);
  const [idActions, setIdActions] = useState(null);
  const [processInfo, setProcessInfo] = useState(null);
  const [jsonData, setJsonData] = useState(null);
  const firstUpdate = useRef(true);
  const translations = {
    previousText: 'Anterior',
    nextText: 'Próximo',
    loadingText: 'Carregando...',
    noDataText: 'Nenhum evento encontrado',
    pageText: 'Página',
    ofText: 'de',
    rowsText: 'linhas',
  };

  useEffect(() => {
    setProcessInfo(props.processObject);
  }, [props.processObject]);

  useEffect(() => {
    (async () => {
      const result = await axios.get(`/actions/${props.idAction}/templates`);
      setIdActions(result.data);
    })();
  }, [props.idAction]);

  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    let previousJson = [];

    idActions.forEach(action => {
      previousJson.push({
        template_name: action.template_name,
        action_id: action.action_id,
        template_id: action.id,
      });
    });

    setJsonData(previousJson);
  }, [idActions]);

  function createColumns() {
    return [
      {
        Header: 'Nome',
        id: 'template_name',
        show: true,
        accessor: d => d.template_name,
      },
    ];
  }

  function getTemplateClicked(id) {
    return idActions.find(element => element.id === id);
  }

  const onRowClick = (state, rowInfo, column, instance) => {
    return {
      onClick: e => {
        if (rowInfo !== undefined) {
          const actionId = rowInfo.original.action_id;
          const templateId = rowInfo.original.template_id;
          const jsonMessage = [];
          jsonMessage.push(processInfo);
          jsonMessage.push(getTemplateClicked(templateId));
          history.push(`/template/${actionId}`, jsonMessage);
        }
      },
    };
  };

  return (
    <div>
      {!props.processObject.isRecordEdit ? (
        <Button onClick={() => reference && reference._show()}>
          <Description />
        </Button>
      ) : (
        <Button onClick={() => reference && reference._show()}>
          <Done />
        </Button>
      )}

      <OpacityModal
        modalRef={ref => setReference(ref)}
        containerStyle={{
          padding: '20px',
          maxWidth: '80%',
          width: '800px',
          height: '400px',
        }}
      >
        <div className="flex-column">
          <h2>Minutas disponíveis</h2>
          <span style={{ marginTop: 2, marginBottom: 10 }}>
            (Selecione a linha para edição)
          </span>
        </div>

        <div style={{ paddingLeft: 20, paddingRight: 20 }}>
          <ReactTable
            {...translations}
            data={jsonData}
            columns={createColumns()}
            defaultPageSize={5}
            showPageSizeOptions={false}
            getTdProps={onRowClick}
          />
        </div>
      </OpacityModal>
    </div>
  );
}

export default TemplateModal;
